import React from 'react';
import { useLocation } from 'react-router-dom';
import { I18n } from 'i18n';
import { useSelector } from 'react-redux';
import { Layout } from 'antd';
import { Sider, Main } from '../components';
import { Log } from '../../water-preparation/views/log';
import { GraphicLog } from '../../water-preparation/views/historic-log';

const ROUTES = [
  {
    key: 'daily-graph',
    name: I18n('daily_graph', true),
    path: '/water-quality/water-preparation/daily-graph',
    component: GraphicLog,
  },
  {
    key: 'table',
    name: I18n('data_table', true),
    path: '/water-quality/water-preparation/table',
    component: Log,
  },
];

export function WaterPreparation() {
  const { collapseNav } = useSelector(({ app }) => app);
  const { pathname } = useLocation();
  const location = pathname.split('/');
  return (
    <Layout>
      {!collapseNav && (
        <Sider
          ROUTES={ROUTES}
          defaultSelectedKeys={location[3]}
          title={I18n('water_preparation', true)}
          key={'water-preparation'}
        />
      )}
      <Main ROUTES={ROUTES} collapseNav={collapseNav} breadcrumb={location} />
    </Layout>
  );
}
